import React from "react";
import { steps } from "../mock";

export default function Process() {
  return (
    <section id="process" className="section-cream">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-28">
        <p className="eyebrow eyebrow-line">How We Engage</p>
        <h2 className="font-serif-display mt-6 text-[2.1rem] md:text-[3rem] leading-[1.05] text-[#2a3325] max-w-3xl">
          Four steps, transparent <span className="italic-accent">throughout</span>.
        </h2>

        <div className="mt-16 relative">
          <div className="hidden md:block absolute top-8 left-0 right-0 h-px bg-[#c4cfb2]" />
          <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
            {steps.map((s) => (
              <div key={s.n} className="relative">
                <div className="flex items-center justify-between">
                  <span className="font-serif-display text-[3rem] leading-none italic-accent">{s.n}</span>
                  <span className="hidden md:inline-block w-2 h-2 rounded-full bg-[#8a9a6b]" />
                </div>
                <h3 className="font-serif-display text-2xl text-[#2a3325] mt-6">{s.title}</h3>
                <p className="mt-3 text-[#4d5a45] leading-relaxed text-sm">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
